import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { alterarSenhaPropria } from "../../api/usuarios";
import { useAuth } from "../../auth/AuthContext";
import "./TrocarSenhaObrigatoria.scss";

export default function TrocarSenhaObrigatoria() {
  const navigate = useNavigate();
  const { sair } = useAuth();
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirma, setConfirma] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (novaSenha.length < 6) {
      Swal.fire(
        "Atenção",
        "A nova senha precisa ter ao menos 6 caracteres.",
        "warning",
      );
      return;
    }
    if (novaSenha !== confirma) {
      Swal.fire("Atenção", "As senhas não coincidem.", "warning");
      return;
    }
    if (novaSenha === senhaAtual) {
      Swal.fire(
        "Atenção",
        "A nova senha precisa ser diferente da atual.",
        "warning",
      );
      return;
    }
    setLoading(true);
    try {
      await alterarSenhaPropria(senhaAtual, novaSenha);
      await Swal.fire(
        "Pronto!",
        "Senha alterada. Faça login novamente.",
        "success",
      );
      await sair();
      navigate("/", { replace: true });
    } catch (err) {
      Swal.fire(
        "Erro",
        err?.message || "Não foi possível alterar a senha.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="trocar-senha">
      <form onSubmit={submit} className="trocar-senha__card">
        <h1>Troca de senha obrigatória</h1>
        <p className="trocar-senha__sub">
          Por segurança, você precisa definir uma nova senha antes de continuar.
        </p>

        <label>
          Senha atual
          <input
            type="password"
            value={senhaAtual}
            onChange={(e) => setSenhaAtual(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        <label>
          Nova senha
          <input
            type="password"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            autoComplete="new-password"
            required
            minLength={6}
          />
        </label>
        <label>
          Confirmar nova senha
          <input
            type="password"
            value={confirma}
            onChange={(e) => setConfirma(e.target.value)}
            autoComplete="new-password"
            required
            minLength={6}
          />
        </label>

        <button type="submit" disabled={loading}>
          {loading ? "Salvando..." : "Salvar nova senha"}
        </button>
      </form>
    </div>
  );
}
